// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * Tile slider indicator component
 * Displays progress indicators for slider functionality
 */
let TileSliderIndicator = class TileSliderIndicator extends Vue {
    /**
     * Determines whether the slider indicator should be shown
     */
    get shouldShow() {
        return !!(this.sliderIndicator && this.sliderIndicator.slidesCount > 1);
    }
    /**
     * Prepared data for slider indicator segments
     */
    get segments() {
        var _a;
        if (!this.sliderIndicator) {
            return [];
        }
        const segments = [];
        for (let i = 0; i < this.sliderIndicator.slidesCount; i++) {
            const isActive = i === this.sliderIndicator.activeIndex;
            const segment = {
                key: i,
                cssClasses: {
                    '--active': isActive,
                    '--paused': isActive && !!((_a = this.sliderIndicator) === null || _a === void 0 ? void 0 : _a.isPaused)
                },
                barStyle: this.getSliderBarStyle(isActive)
            };
            segments.push(segment);
        }
        return segments;
    }
    goTo(segmentKey) {
        this.$emit('go-to', segmentKey);
    }
    /**
     * Gets the style for the slider progress bar
     */
    getSliderBarStyle(isActive) {
        if (!isActive || !this.sliderIndicator || !this.sliderIndicator.durationMs) {
            return {};
        }
        return {
            animationDuration: `${this.sliderIndicator.durationMs}ms`
        };
    }
};
__decorate([
    Prop({
        type: Object,
        required: false,
        default: null
    })
], TileSliderIndicator.prototype, "sliderIndicator", void 0);
TileSliderIndicator = __decorate([
    Component({
        name: 'TileSliderIndicator',
        template: `
    <div v-if="shouldShow" class="tile__slider-indicator">
      <button v-for="segment in segments" :key="segment.key" class="tile__slider-indicator__segment"
          :class="segment.cssClasses" @click="() => goTo(segment.key)">
        <span class="tile__slider-indicator__segment__bar" :style="segment.barStyle" />
      </button>
    </div>
  `
    })
], TileSliderIndicator);
export { TileSliderIndicator };
